import { FormControl } from '@startuptools/ui/joy/FormControl';
import { FormHelperText } from '@startuptools/ui/joy/FormHelperText';
import { FormLabel } from '@startuptools/ui/joy/FormLabel';
import { NumericFormatInput } from '@startuptools/ui/NumericFormatInput';
import { Controller, UseFormReturn } from 'react-hook-form';
import { FormData, ExtractKeysOfValueType } from '../types';
import React from 'react';

interface BoardLimitProps {
  children: (values: { min: React.ReactNode; max: React.ReactNode }) => React.ReactNode;
  form: UseFormReturn<FormData>;
  min: NonNullable<ExtractKeysOfValueType<FormData, string | null | undefined>>;
  max: NonNullable<ExtractKeysOfValueType<FormData, string | null | undefined>>;
}

export const BoardLimit = ({ children, form, min, max }: BoardLimitProps) => (
  <FormLabel>
    {children({
      min: (
        <Controller
          control={form.control}
          name={min}
          key={min}
          rules={{ required: true, min: 0 }}
          render={({ field, fieldState }) => (
            <FormControl
              error={!!form.formState.errors[min]}
              sx={{
                display: 'inline-flex',
                mx: '4px',
              }}
            >
              <NumericFormatInput
                size="sm"
                sx={{ maxWidth: '50px' }}
                value={field.value ?? ''}
                onChange={value => field.onChange(value)}
                decimalScale={0}
              />
              {fieldState.error && <FormHelperText>{fieldState.error.message}</FormHelperText>}
            </FormControl>
          )}
        />
      ),
      max: (
        <Controller
          control={form.control}
          name={max}
          key={max}
          rules={{
            required: true,
          }}
          render={({ field, fieldState }) => (
            <FormControl
              error={!!form.formState.errors[max]}
              sx={{
                display: 'inline-flex',
                mx: '4px',
              }}
            >
              <NumericFormatInput
                size="sm"
                sx={{ maxWidth: '50px' }}
                value={field.value ?? ''}
                onChange={value => field.onChange(value)}
                decimalScale={0}
              />
              {fieldState.error && <FormHelperText>{fieldState.error.message}</FormHelperText>}
            </FormControl>
          )}
        />
      ),
    })}
  </FormLabel>
);
